import type { CatalogOption } from '../../reserva/types'

/** Copiado de src/libs/mobbscan/mobbscan-utils.ts de la app actual (mapeo por los literales del PMS). */
export function getIdentifierTypeId(scanType: string, identifierTypes: CatalogOption[]): string {
  if (scanType === 'PASAPORTE') return identifierTypes.find((it) => it.value === 'Pasaporte')?.id ?? ''
  if (scanType === 'DNI') return identifierTypes.find((it) => it.value === 'Documento de identidad')?.id ?? ''
  return identifierTypes.find((it) => it.value === 'Permiso de residencia')?.id ?? ''
}

export function getSexId(gender: string | undefined, sexes: CatalogOption[]): string {
  if (gender === 'M') return sexes.find((s) => s.value === 'hombre')?.id ?? ''
  return sexes.find((s) => s.value === 'mujer')?.id ?? ''
}

export function uppercaseToCapitalize(value?: string): string {
  if (!value) return ''
  return value
    .split(' ')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLocaleLowerCase())
    .join(' ')
}
